import React from 'react'
import {injectIntl} from 'react-intl'
import {Chart, ArcElement, BarElement, BarController, DoughnutController,
    PieController, LinearScale, CategoryScale, Legend, Tooltip} from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import {chartType, barDirection, barSize, pieInnerRadius, pieLegendPosition} from 'utils/enums/graphics'
import theme from 'utils/enums/theme'
import {valueFormatter} from 'utils/utils'

class Graphic extends React.Component {
    constructor(props) {
        super(props)

        this.chartRef = React.createRef()
        Chart.register(ArcElement, BarElement, BarController, DoughnutController,
            PieController, LinearScale, CategoryScale, Legend, Tooltip)
        Chart.unregister(ChartDataLabels)
    }

    componentDidMount() {
        const me = this
        const scheme = Object.values(theme).find(item => item.id === this.props.colorScheme)
        const size = Object.values(barSize).find(item => item.id === this.props.part.width)
        const radius = Object.values(pieInnerRadius).find(item => item.id === this.props.part.radius)
        const legend = Object.keys(pieLegendPosition).find(item => pieLegendPosition[item] === this.props.part.legend)

        this.myChart = new Chart(this.chartRef.current, {
            type: this.props.type === chartType.bar.code ? 'bar' : 'doughnut',
            data: {
                labels: this.props.data.map(item => item.label),
                datasets: [{
                    data: this.props.data.map(item => item.value),
                    backgroundColor: this.props.data.map((item, index) => `rgba(${scheme.colors[index % scheme.colors.length]}, 0.7)`),
                    borderColor: this.props.data.map((item, index) => `rgba(${scheme.colors[index % scheme.colors.length]}, 1)`),
                    categoryPercentage: size ? size.value : null,
                    barPercentage: 1.0,
                    borderWidth: 1,
                    datalabels: {
                        labels: {
                            labels: {
                                formatter: function(value, context) {
                                    return context.chart.data.labels[context.dataIndex]
                                },
                                anchor: 'end',
                                align: 'end',
                                clamp: 'true',
                                clip: 'true',
                                offset: 10,
                                display: this.props.type === chartType.pie.code && this.props.part.showLabels
                            },
                            percents: {
                                formatter: function(value, context) {
                                    const val = Math.round(value / context.dataset.data.reduce((value, item) => value + item) * 100)
                                    return !!val ?  val + '%' : null
                                },
                                anchor: 'center',
                                align: 'end',
                                clamp: 'true',
                                clip: 'true',
                                display: this.props.type === chartType.pie.code && this.props.part.showPercents
                            },
                            values: {
                                formatter: function(value) {
                                    return value
                                },
                                anchor: 'end',
                                align: 'end',
                                clamp: 'true',
                                clip: 'true',
                                display: this.props.type === chartType.bar.code && this.props.part.showValues
                            }
                        }
                    }
                }]
            },
            plugins: this.props.part.showValues ||
                this.props.part.showLabels ||
                this.props.part.showPercents ? [ChartDataLabels] : [],
            options: {
                indexAxis: this.props.part.direction === barDirection.vertical ? 'x' : 'y',
                cutout: radius ? radius.value + '%' : null,
                maintainAspectRatio: false,
                plugins: {
                    legend: {
                        display: !!this.props.part.legend,
                        position: legend
                    },
                    tooltip: {
                        callbacks: {
                            label: (context) => {
                                const value = context.dataset.data[context.dataIndex]
                                const string = valueFormatter(value, this.props.fieldValueId)
    
                                return `  ${string}`
                            }
                        }
                    }
                },
                scales: {
                    y: {
                        ticks: {
                            callback: function (value) {
                                return me.props.type === chartType.pie.code ? null :
                                me.props.part.direction === barDirection.vertical ?
                                    valueFormatter(value, me.props.fieldValueId) : this.getLabelForValue(value)
                            },
                            beginAtZero: true
                        },
                        display: this.props.type === chartType.pie.code ? false : true
                    },
                    x: {
                        ticks: {
                            callback: function (value) {
                                return me.props.type === chartType.pie.code ? null :
                                me.props.part.direction === barDirection.horizontal ?
                                    valueFormatter(value, me.props.fieldValueId) : this.getLabelForValue(value)
                            }
                        },
                        display: this.props.type === chartType.pie.code ? false : true
                    }
                }
            }
        })
    }

    componentDidUpdate(props) {
        const scheme = Object.values(theme).find(item => item.id === this.props.colorScheme)

        this.myChart.data.labels = this.props.data.map(item => item.label)
        this.myChart.data.datasets[0].data = this.props.data.map(item => item.value)
        this.myChart.data.datasets[0].backgroundColor = this.props.data.map((item, index) => `rgba(${scheme.colors[index % scheme.colors.length]}, 0.7)`)
        this.myChart.data.datasets[0].borderColor = this.props.data.map((item, index) => `rgba(${scheme.colors[index % scheme.colors.length]}, 1)`)
        this.myChart.update()
    }

    render() {
        return (
            <canvas ref={this.chartRef} />
        )
    }
}

export default injectIntl(Graphic)
